import { createApi } from '@reduxjs/toolkit/query/react';

import { generateBaseQuseryWithReAuth } from '@/store/baseQueryReauth';

export const avatarProfileApi = createApi({
  reducerPath: 'avatarProfileApi',
  keepUnusedDataFor: 300,
  baseQuery: generateBaseQuseryWithReAuth({ basePath: '', isAvatarProfileApis: true }),
  tagTypes: ['GetAvatar', 'UploadAvatar'],
  endpoints: builder => ({
    getCustomerAvatar: builder.query<Blob, { id: number | undefined; type?: string; cache?: boolean }>({
      query: ({ id, type = 'default', cache = true }) => ({
        url: `/profiles/avatar/${id}/${type}/${cache}`,
        method: 'GET',
        headers: {
          'Content-Type': 'image/png',
        },
        next: { tags: ['GetAvatar'] },
        priority: 'low',
        responseHandler: response => response.blob(),
      }),
      providesTags: ['GetAvatar'],
    }),
    updateAvatar: builder.mutation<any, { image: File; cache?: boolean }>({
      query: ({ image, cache = true }) => {
        const formData = new FormData();
        formData.append('file', image);
        formData.append('cache', cache.toString());

        return {
          url: '/api/App/SaveAvatar',
          method: 'POST',
          body: formData,
        };
      },
      transformResponse: (response: any) => response,
      invalidatesTags: ['UploadAvatar'],
    }),
  }),
});

export const { useGetCustomerAvatarQuery, useUpdateAvatarMutation } = avatarProfileApi;
